import { EditButton, Show, SimpleShowLayout } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import ShowView from "./Partials/ShowView";
import CompleteMobilityDialog from "./components/CompleteMobilityDialog";

const ShowErasmusIncomingTeachers = () => {
  return (
    <Show
      title="Детайли на пристигащ преподавател за обучение"
      actions={
        <BackButtonToolbar
          additionalButton={
            <SecuredComponent permission={permissions.canManageErasmusIncomingTeachers}>
              <CompleteMobilityDialog />
              <EditButton
                variant="contained"
                size="medium"
              />
            </SecuredComponent>
          }
        />
      }
    >
      <SimpleShowLayout>
        <ShowView />
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowErasmusIncomingTeachers;
